import React from "react";

const SupplierLogo = ({ src, alt }) => {
  return (
    <div>
      <img src={src} alt={alt} className="h-10 w-auto flex-shrink-0 m-0" />
    </div>
  );
};

export default SupplierLogo;
